import { useServiceContext } from "@web/route-services/chat/service-context";
import { useEffect } from "react";
export const useSwitchOnArrow = () => {
  const { service } = useServiceContext();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const activeElement = document.activeElement;
      const isInputFocused =
        activeElement &&
        (activeElement.tagName === "INPUT" ||
          activeElement.tagName === "TEXTAREA" ||
          (activeElement as HTMLElement)?.isContentEditable);

      if (isInputFocused) {
        return;
      }
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        service.switchLeft();
      } else if (event.key === "ArrowRight") {
        event.preventDefault();
        service.switchRight();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [service]);
};
